<template>
  <el-col class="user">
    <el-menu
      mode="horizontal"
      @open="open">
      <el-submenu index="6" class="login-user" popper-class="login-user">
        <template slot="title"><div class="user-icon"><div class="el-icon-user-solid"></div></div></template>
        <el-menu-item-group :title="loginUserName">
          <el-menu-item @click="editUser">ユーザー情報</el-menu-item>
          <el-menu-item @click="changePassword">パスワード変更</el-menu-item>
          <el-menu-item @click="logOff">ログアウト</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <UserMasterEditDialog
      :visible.sync="editDialogVisible"
      :current-row="currentRow"
      programName="UserInformation"
    />
    <UserMasterChangePasswordDialog
      :current-row="currentRow"
      :visible.sync="changePasswordDialogVisible"
    />
  </el-col>
</template>

<script>
import UserMasterEditDialog from '@/components/pages/master/cognitoUserMaster/UserMasterEditDialog.vue'
import UserMasterChangePasswordDialog from '@/components/pages/master/cognitoUserMaster/UserMasterChangePasswordDialog.vue'
import { Auth } from 'aws-amplify'

export default {
  components: {
    UserMasterEditDialog,
    UserMasterChangePasswordDialog
  },
  data () {
    return {
      tableData: [],
      editDialogVisible: false,
      changePasswordDialogVisible: false,
      currentRow: {},
      loginUserName: this.$loginuser.get('user_name')
    }
  },
  methods: {
    async logOff (e) {
      try {
        this.$loadingMask.on()
        await Auth.signOut()
        this.$session.destroy()
        this.$router.push({ path: '/' })
      } catch (e) {
        alert(e)
      } finally {
        this.$loadingMask.off()
      }
    },
    open () {
      const userRect = this.$el.getBoundingClientRect()
      const subMenu = document.querySelector('.el-menu--horizontal.login-user')
      const subMenuRect = subMenu.getBoundingClientRect()
      subMenu.style.left = (userRect.right - subMenuRect.width) + 'px'
    },
    async editUser () {
      await this.get_user()
      this.currentRow = this.tableData[0]
      this.editDialogVisible = true
    },
    async get_user () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(JSON.stringify({ user_id: this.$loginuser.get('username') }))
      searchCond.syori = 'one_record'
      await this.$axios
        .get('/search-user', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    async changePassword () {
      await this.get_user()
      this.currentRow = this.tableData[0]
      this.currentRow.login_user_id = this.$loginuser.get('username')
      this.changePasswordDialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.user {
  flex-grow: 0;
  width: 2.7em;
  height: inherit;
  display: flex;
  justify-content: end;
  align-items: center;
  ::v-deep ul.el-menu {
    height: 100%;
    border-bottom-style: none;
    .login-user {
      height: 100%;
      .el-submenu__title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: black;
        background-color: var(--background-color);
        height: inherit;
        line-height: inherit;
        padding: 0;
        >div {
          display: inline-block;
          &.user-icon {
            position: relative;
            height: inherit;
            width: 2em;
            .el-icon-user-solid {
              font-size: inherit;
              &::before {
                font-size: 2.4em;
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                height: 1.1em;
                width: 1.1em;
                background-color: var(--primary-background-color);
                border-radius: 50%;
                box-sizing: border-box;
                color: var(--primary-fore-color);
                padding-top: 0.5rem;
                clip-path: circle(50% at center);
              }
              &::after {
                content: "";
                font-size: 2.4em;
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                height: 1.1em;
                width: 1.1em;
                box-sizing: border-box;
                border: solid 0.1em var(--primary-border-color);
                border-radius: 50%;
              }
            }
          }
        }
      }
      .el-submenu__icon-arrow {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
div.el-menu--horizontal {
  &.login-user {
    position: fixed !important;
    --sub-menu-width: 11.5em;
    width: var(--sub-menu-width);
    top: var(--header-height) !important;
    left: calc(50vw + (var(--content-width) / 2) - var(--sub-menu-width)) !important;
    .el-menu.el-menu--popup {
      margin-top: 0;
      background-color: var(--primary-background-color);
      border-radius: 0.5rem;
      padding: 0.5rem;
      .el-menu-item-group__title {
        padding: 0 0.5em 0.2em !important;
        color: var(--primary-fore-color);
      }
      .el-menu-item {
        color: black;
        margin-top: 0m;
        margin-bottom: 0;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        &:hover {
          color: var(--primary-fore-color);
          background-color: var(--primary-background-color);
        }
      }
    }
  }
}
</style>
